export default __webpack_public_path__ + "static/media/whyregister.d47941ac.jpg";